module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (82).5a835d84.jpg";